import { BubbleHaloMetadata } from '@/components/public/Visualisations/BubblesV2/Metadata'
import { XYBubbleMetadata } from './XYBubbleMetadata'

export class XYBubbleHaloMetadata extends BubbleHaloMetadata {
  private _xyBubbleMetadata: XYBubbleMetadata

  constructor(bubbleMetadata: XYBubbleMetadata) {
    super(bubbleMetadata)
    this._xyBubbleMetadata = bubbleMetadata
  }

  get key() {
    return this._xyBubbleMetadata.key
  }
}
